import type { MerchantPreset } from './types';

export const NEUTRAL_MERCHANT_ID = 'neutral';

/**
 * Generic defaults for every host that is not a known merchant. Labels are ones
 * `useBusinessActions` already routes (order status / product question / return).
 */
export const NEUTRAL_MERCHANT_PRESET: MerchantPreset = Object.freeze({
  id: NEUTRAL_MERCHANT_ID,
  suggestedActions: ['Order Status', 'Product Question', 'Return / Exchange'],
  cart: { openCartAfterAdd: true },
}) as MerchantPreset;
